export const coresGestaoEnvio = {
  vermelho: '#b53838',
  verde: '#2dc44d',
  azul: '#3286a8',
  verde_amarelado: '#d9e26e',
  laranja: '#eeac5c',
  roxo: '#5D26C1',
};
